<template>
  <section>
    <div class="title" style="padding:20px">部门管理</div>
    <div class="pad10">
      <el-button type="primary" @click="append({id:0,pid:0})">新增部门</el-button>
    </div>
    <el-tree
      :data="departmentList"
      show-checkbox
      node-key="id"
      :props="{children:'_child'}"
      default-expand-all
      :expand-on-click-node="false"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ data.name }}</span>
        <span>
          <el-button size="mini" type="primary" @click="() => append(data)">添加子集</el-button>
          <el-button size="mini" @click="() => append(data,true)">编辑</el-button>
          <el-button size="mini" @click="soprnshouxinbox(data.id,'shouxinLog')">授信支出记录</el-button>
          <el-button size="mini" @click="soprnshouxinbox(data.id,'shouxinOrder')">授信订单</el-button>
          <!-- <el-button size="mini" @click="soprnshouxinbox(data.id,'allOrder')">全部订单</el-button> -->
          <el-button type="danger" size="mini" @click="() => remove(node, data)">删除</el-button>
        </span>
      </span>
    </el-tree>
    <!-- 授信列表 -->
    <el-dialog title="查看授信" :visible.sync="shouxinVisible" destroy-on-close>
      <el-table :data="balanceList.list.data" v-if="boxtype=='shouxinLog'">
        <el-table-column property="" label="最近3个月" width="180">
           <template slot-scope="scope">
              <div>{{ scope.row.addtime }}</div>
          </template>
        </el-table-column>
        <el-table-column property="" label="金额" width="100">
           <template slot-scope="scope">
              <div>{{ scope.row.amount }}</div>
          </template>
        </el-table-column>
        <el-table-column property="" label="类型" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.classfy }}</div>
          </template>
        </el-table-column>
        <el-table-column property="" label="详细说明">
            <template slot-scope="scope">
              <div>{{ scope.row.remark1 }}</div>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="boxtype=='shouxinOrder'"
        ref="multipleTable"
        :data="jiesuanorder.data"
        border
        tooltip-effect="dark" >
        <el-table-column prop="addtime" label="下单时间"></el-table-column>
        <el-table-column prop="orderno" label="订单号"></el-table-column>
        <el-table-column prop="" label="商品金额" width="80">
           <template slot-scope="scope">
              <div>{{ scope.row.total }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="运费" width="80">
            <template slot-scope="scope">
              <div>{{ scope.row.shipfee }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="discount" label="优惠"></el-table-column>
        <el-table-column prop="" label="实付款" width="80">
            <template slot-scope="scope">
              <div>{{ scope.row.amount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品信息" width="320">
          <template slot-scope="scope">
            <div class="goodsInfo" v-for="(item_i,index_i) in scope.row.detail" :key="index_i">
              <div class="clearfix cpinfo flex">
                <div class="img">
                  <a :href="'#/goodsdetail?id='+ item_i.productid" target="_blank">
                    <img :src="item_i.indexpic" style="width:80px"/>
                  </a>
                </div>
                <div class="cont ellipsis-2">
                  <div class="name">{{item_i.title}}</div>
                  <div class="info">{{item_i.specnames}}</div>
                </div>
                <div class="cart-price">{{item_i.price}}*{{item_i.num}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="allOrder.data" border v-if="boxtype=='allOrder'">
        <el-table-column label="订单信息" width="120">
          <template slot-scope="scope">
            <div class="text_l">
              <div>{{ scope.row.orderno }}</div>
              <br />
              <div>{{ scope.row.addtime }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="total" label="商品金额" width="80"></el-table-column>
        <el-table-column prop="shipfee" label="运费" width="80"></el-table-column>
        <el-table-column prop="discount" label="优惠" width="80"></el-table-column>
        <el-table-column prop="amount" label="实付款" width="80"></el-table-column>
        <el-table-column label="商品信息" width="320">
          <template slot-scope="scope">
            <div class v-for="(item_i,index_i) in scope.row.detail" :key="index_i">
              <div class="clearfix cpinfo flex">
                <div class="img">
                  <a :href="'#/goodsdetail?id='+ item_i.productid" target="_blank">
                    <img :src="item_i.indexpic" />
                  </a>
                </div>
                <div class="cont">
                  <div class="name ellipsis-2">{{item_i.title}}</div>
                  <div class="info">{{item_i.specnames}}</div>
                  <div class="cart-price">{{item_i.price}}*{{item_i.num}}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="状态" width="100"> <template slot-scope="scope">
              <div>{{ scope.row.statusText }}</div>
  
          </template></el-table-column>
      </el-table>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page_size="page_size"
        @current-change="currentPagegoods"
        :total="total"
      ></el-pagination>
    </el-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      departmentList: [],
      page: 1,
      boxtype: "",
      departid: "",
      page_size: 10,
      total: 10,
      jiesuanorder: { data: [] },
      allOrder: { data: [] },
      balanceList: { list: { data: [] } },
      shouxinVisible: false
    };
  },
  methods: {
    append(data, edit) {
      this.$prompt("请输入名称", "提示", {
        confirmButtonText: "确定",
        customClass: "yijianbox",
        cancelButtonText: "取消",
        inputValue: edit ? data.name : ""
      })
        .then(async ({ value }) => {
          value = value.replace(/^\s*|\s*$/g, "");
          console.log(value.length);
          if (!value) {
            this.$message({
              type: "error",
              message: "请输入内容 "
            });
            return;
          }
          let $data = { name: value, pid: data.id };
          if (edit) {
            $data = { name: value, pid: data.pid, id: data.id };
          }
          let res = await this.$fetch("shop/department", {
            body: {
              act: "edit",
              data: $data
            }
          });
          if (res) {
            this.$message({ type: "success", message: "提交成功" });
            this.getdepartmentList();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    currentPagegoods(e) {
      this.page = e;
      this.soprnshouxinlist();
    },
    soprnshouxinbox(departid, boxtype) {
      this.departid = departid;
      this.page = 1;
      this.boxtype = boxtype;
      this.soprnshouxinlist();
    },
    async soprnshouxinlist() {
      let departid = this.departid;
      const loading = this.$loading({
        lock: true,
        text: "查询中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (this.boxtype == "shouxinLog") {
        let balanceList = await this.$fetch("member/balance", {
          body: { departid, page: this.page, type: "account3" }
        });
        let arr = balanceList.list.data;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].type == 1) {
            arr[i].amount = "+" + arr[i].amount;
          } else {
            arr[i].amount = "-" + arr[i].amount;
          }
          for (let key in balanceList.typelist) {
            if (arr[i].typeid == key) {
              arr[i]["classfy"] = balanceList.typelist[key];
            }
          }
        }
        this.page_size = balanceList.list.per_page;
        this.total = balanceList.list.total;
        this.balanceList = balanceList;
      } else if (this.boxtype == "shouxinOrder") {
        let jiesuanorder = await this.$fetch("order/ordertopay", {
          body: { departid, page: this.page, isauthpaid: 0, isexpire: 0 }
        });
        console.log("授信订单", jiesuanorder);
        this.jiesuanorder = jiesuanorder;
        this.page_size = jiesuanorder.per_page;
        this.total = jiesuanorder.total;
      } else if (this.boxtype == "allOrder") {
        let res = await this.$fetch("Member/orderlist", {
          body: {
            page: this.page,departid
          }
        });
        for (let i = 0; i < res.data.length; i++) {
          let text = "";
          if (res.data[i].status == 0) {
            text = "待付款";
          } else if (res.data[i].status == 1) {
            text = "待发货";
          } else if (res.data[i].status == 2) {
            text = "待收货";
          } else if (res.data[i].status == 3) {
            text = "已完成";
          } else if (res.data[i].status == 4) {
            text = "已取消";
          } else if (res.data[i].status == 5) {
            text = "已退款";
          }
          res.data[i]["statusText"] = text;
          // for (let j = 0; j < res.data[i].detail.length; j++) {
          //   if (res.data[i].detail[j].iscomment == 0) {
          //     res.data[i]["iscomment"] = true;
          //     break;
          //   }
          // }
        }
        this.page_size = res.per_page;
        this.total = res.total;
        this.allOrder = res;
      }

      loading.close();
      this.shouxinVisible = true;
    },

    async remove(node, data) {
      console.log(node, data);
      let res = await this.$fetch("shop/department", {
        body: {
          act: "delete",
          data: { id: data.id }
        }
      });
      this.getdepartmentList();
    },
    // 获取部门列表
    async getdepartmentList() {
      let departmentList = await this.$fetch("shop/department", {
        body: {
          act: "list"
        }
      });
      console.log("departmentListdepartmentList", departmentList);
      this.departmentList = departmentList;
    }
  },
  mounted() {
    this.getdepartmentList();
  }
};
</script>
<style lang='scss' scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-tree-node__content {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/department.vue